import AttributeRow from './AttributeRow';
import styles from './styles/AttributeRowColors.module.scss';

export default function AttributeRowColors({ colors }: { colors: string | string[] }) {
  return (
    <AttributeRow title="Colors">
      <div className={styles.Circles}>
        {[colors].flat().map((color, i) => (
          <div key={i} className={styles.Circle} style={{ backgroundColor: color || 'transparent' }}></div>
        ))}
      </div>
    </AttributeRow>
  );
}
